export class AssembleClassInfo {
  description: string;
  highlights: any[];
}
